/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getWorkHistoryList } from "../../../apis/work-history";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import { isEmpty } from "../../../utils/lodashExtend";
import { getParams } from "../../../utils/params";
import { permissionCheck } from "../../../utils/permission";
import { getTimeString } from "../../../utils/work-schedule-calculator";

const AttendanceWorkTime = (props) => {
  const history = useHistory()
  const { parts, employees, permissions } = useSelector(
    (store) => ({
      parts: store.Data.parts,
      employees: store.Data.employees,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );
  const [fields, setFields] = useState([]);
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      const permission = permissions.find(p => p.code === 'WORK_TIME_MANAGEMENT')
      setTargetPermission(permission)
      if (isEmpty(permission))
      {
        permissionCheck(history, "WORK_TIME_MANAGEMENT")
      }
    }
  }, [permissions])

  useEffect(() => {
    setFields([
      {
        title: "부서",
        key: "partIdx",
        onTranslator: {
          list: [
            ...parts.map((part) => ({
              label: part.partName,
              value: part.idx,
            })),
          ],
        },
      },
      {
        title: "이름",
        key: "employeeIdx",
        type: 'profile'
      },
      {
        title: "일반",
        key: "workday.admitWorkTimeInSeconds",
        onValue: (value) => {
          return getTimeString(value);
        },
      },
      {
        title: "연장",
        key: "workday.extendWorkTimeInSeconds",
        onValue: (value) => {
          return getTimeString(value);
        },
      },
      {
        title: "야간",
        key: "workday.nightWorkTimeInSeconds",
        onValue: (value) => {
          return getTimeString(value);
        },
      },
      {
        title: "휴일 일반",
        key: "holiday.admitWorkTimeInSeconds",
        onValue: (value) => {
          return getTimeString(value);
        },
      },
      {
        title: "휴일 연장",
        key: "holiday.extendWorkTimeInSeconds",
        onValue: (value) => {
          return getTimeString(value);
        },
      },
      {
        title: "휴일 야간",
        key: "holiday.nightWorkTimeInSeconds",
        onValue: (value) => {
          return getTimeString(value);
        },
      },
      {
        title: "합계",
        key: "total",
        onValue: (value, field, data) => {
          const { workday, holiday } = data;
          const total =
            workday.admitWorkTimeInSeconds +
            workday.extendWorkTimeInSeconds +
            workday.nightWorkTimeInSeconds +
            holiday.admitWorkTimeInSeconds +
            holiday.extendWorkTimeInSeconds +
            holiday.nightWorkTimeInSeconds;

          return getTimeString(total);
        },
      },
    ]);
  }, [parts, employees]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: {},
      range: {
        workDate: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  )


  useEffect(() => {
    if (targetPermission)
    {
      submit(form);
      setSubmit(submit)
    }
  }, [targetPermission]);

  const submit = ({ partIdx, employeeIdxs, ...form }) => {
    if (!isEmpty(employeeIdxs))
    {
      form.search.employeeIdxs = employeeIdxs.map(e => e.idx)
    } else
    {
      form.search.employeeIdxs = ""
    }

    if (!isEmpty(partIdx))
    {
      form.search.partIdx = Number(partIdx)
    } else
    {
      form.search.partIdx = ""
    }

    setIsLoading(true);
    getWorkHistoryList(getParams(form))
      .then((res) => {
        setList(res.data.histories);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const filters = [
    {
      title: "조회기간",
      key: 'range.workDate',
      type: "customdatepicker",
    },
    {
      title: "부서",
      type: "select",
      key: "partIdx",
      options: {
        list: [
          { label: "전체", value: "" },
          ...parts.map((part) => ({ label: part.partName, value: part.idx })),
        ],
      },
    },
    {
      title: "사람 검색",
      type: "searchEmployee",
      key: "employeeIdxs",
    },
  ]

  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        <PageHeader title={"근로시간 관리"} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
        />
      </div>
    )
  );
};

export default AttendanceWorkTime;
